module.exports = __webpack_public_path__ + "static/media/DjamelAgaoua@3x.97cf35db.png";